import axios from "axios";

export function INTEREST() {
  return new Promise((resolve, reject) => {
    axios
      .get("/v1/wallets/transferFees")
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
        console.log(e);
      });
  });
}
